import React from 'react';
import { useEffect, useState } from 'react';

import * as CONSTANTS from "../constants";
import * as OPTIONS from "../option-fields";
import * as UTILS from "../utils";
import { getBasketData, refetchBasketData, getCustomer, NotificationContext, handleError } from "../router"
import IFrame from '../components/iframe';
import BasketUpsellBlock from '../components/basket-upsell';
import MembershipPrompt from './membership-prompt';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/Basket2.aspx?resize=true`;
// console.log()

// const { data: basketData } = getBasketData();



//     useEffect(() => {
//         if (!basketData || !basketData.tickets) return;
        
//         const grouped_tickets = UTILS.groupTicketsByInstance(basketData.tickets);
//         setGroupedEvents(grouped_tickets);

//         const has_upsell = UTILS.ticketsHaveDonationUpsell(basketData.tickets);
//         setHasDonationUpsell(has_upsell);

//     }, [basketData]);

//  useEffect(() => {
//         refetchBasketData();
//     }, [])

export default function IframeBasket() {



        const { data: basketData, isPending: basketDataPending, isFetching: basketDataFetching } = getBasketData();
console.log('Basket data: ', basketData);

    return (
        <div className='booking-pathway__container booking-pathway__iframe-basket'>
            
            <div className='booking-pathway__main-content flex'>
                <h1 className='sr-text'>Basket</h1>

                <IFrame url={iframeURL} title="Basket" hasLoader="true" />
                <MembershipPrompt basketData={basketData} />
                {/* <BasketUpsellBlock content={OPTIONS.BasketMembership} type="help-upsell" /> */}

            </div>
        </div>
    );
}